import { z } from "zod/v4";

import { SubscriptionProductDtoSchema } from "../../../dtos/stripe-api";

export const GetSubscriptionProductsResponseBodySchema = z.object({
  subscriptionProducts: SubscriptionProductDtoSchema.array(),
});

export type GetSubscriptionProductsResponseBodyType = z.infer<
  typeof GetSubscriptionProductsResponseBodySchema
>;
